module.exports = __webpack_public_path__ + "img/Web Application Development.ff407ffe.png";